import Hero from "../components/home/Hero";
import EmiTickerBanner from "../components/home/EmiTickerBanner";
import ValuePacksTeaser from "../components/home/ValuePacksTeaser";
import DynamicSeries from "../components/home/DynamicSeries";
import VoiceAssistant from "../components/home/VoiceAssistant";
import IntelligentLiving from "../components/home/IntelligentLiving";
import SolutionsTiers from "../components/home/SolutionsTiers";
import WhyGenieX from "../components/home/WhyGenieX";
import Testimonials from "../components/home/Testimonials";
import { useSEO } from "../lib/seo";
import { useCmsSeo } from "../lib/cmsSeo";
import { usePageCms } from "../cms/usePageCms";

export default function HomePage({ onBook }) {
  const seo = useCmsSeo("home", {
    title: "Intelligence at Your Command",
    description:
      "GenieX — ultra-premium smart home automation for India. Dynamic Series interactive switches, KNX, WiFi & retro modules. Hyderabad, Vijayawada & all India.",
    jsonLd: [
      // Organization — the master entity Google ties everything else to.
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://geniex.in/#organization",
        name: "GenieX",
        legalName: "GenieX Intelligent Living",
        url: "https://geniex.in",
        logo: "https://geniex.in/logo.png",
        image: "https://geniex.in/renders/dynamic-hero.png",
        description:
          "Ultra-premium smart home automation, designed in the footsteps of Apple. Dynamic Series interactive switches, KNX, Zigbee 3.0, motorised curtains, home theatre and security.",
        slogan: "Intelligence at Your Command.",
        foundingDate: "2022-01-01",
        areaServed: [
          { "@type": "State", name: "Telangana" },
          { "@type": "State", name: "Andhra Pradesh" },
          { "@type": "Country", name: "India" },
        ],
        contactPoint: [{
          "@type": "ContactPoint",
          telephone: "+91-90636-62999",
          contactType: "customer service",
          email: "hello@geniex.in",
          areaServed: "IN",
          availableLanguage: ["English", "Hindi", "Telugu"],
        }],
        sameAs: [
          "https://www.instagram.com/geniex.in",
          "https://www.linkedin.com/company/geniex",
        ],
      },
      // WebSite with SearchAction — enables sitelinks searchbox in SERPs.
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": "https://geniex.in/#website",
        url: "https://geniex.in",
        name: "GenieX",
        inLanguage: "en-IN",
        publisher: { "@id": "https://geniex.in/#organization" },
        potentialAction: {
          "@type": "SearchAction",
          target: "https://geniex.in/blog?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
    ],
  });
  useSEO(seo);

  const { data: pageCms } = usePageCms("home");
  const hero = pageCms.hero || {};
  const vis = pageCms.section_visibility || {};

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="bg-[var(--gx-bg)]">
      <EmiTickerBanner />
      <Hero onBook={onBook} onExplore={() => scrollTo("[data-testid='dynamic-series-section']")} cms={hero} />
      {vis.dynamic_series !== false && <DynamicSeries onBook={onBook} />}
      {vis.value_packs_teaser !== false && <ValuePacksTeaser />}
      {vis.voice_assistant !== false && <VoiceAssistant />}
      {vis.intelligent_living !== false && <IntelligentLiving />}
      {vis.solutions_tiers !== false && <SolutionsTiers onBook={onBook} />}
      {vis.why_geniex !== false && <WhyGenieX onBook={onBook} />}
      {vis.testimonials !== false && <Testimonials />}
    </main>
  );
}
